import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Resume } from '../../../shared/models/resume';
import { environment } from '../../../../environments/environment';
import { CandidatesStore } from '../../store/candidates-store.service';
import { ComponentTypes } from '../../../shared/enums/component-type';
import { CandidateStore } from '../../../dashboards/store/candidate-store';
import { AppStore } from '../../../shared/store/lookup-store.service';
import { EntityTypes } from 'src/app/shared/enums/entity-types';


@Component({
  selector: 'resume-preview',
  templateUrl: './resume-preview.component.html',
  styleUrls: ['./resume-preview.component.scss']
})
export class ResumePreviewComponent implements OnInit {

  resumeId: string;
  resume: Resume;
  showEducationCap: boolean = false;
  showBriefCase: boolean = false;
  photoPath: string = "assets/images/avatar/04.jpg";
  languages: string;
  componentTypes = ComponentTypes;
  entityTypeEnum = EntityTypes;
  constructor(private candidatesStore: CandidatesStore,
    private route: ActivatedRoute,
    private dashboardState: CandidateStore,
    public lookupStore: AppStore,) {
    this.route.params.subscribe(params => this.resumeId = params['resumeId']);

    this.candidatesStore.resume.subscribe(r => {
      if(!r) {
        return;
      }

      this.photoPath = "assets/images/avatar/04.jpg";
      this.resume = r;
      if(this.resume.profile && this.resume.profile.photoPath) {
        this.photoPath = `${environment.baseUrl}/${this.resume.profile.photoPath}`;
      }

      if(this.resume.educations.length > 0) {
        this.showEducationCap = true;
      }

      if(this.resume.experiences.length > 0) {
        this.showBriefCase = true;
      }
      if(this.resume.profile.languages){
        this.languages = Array.prototype.map.call(this.resume.profile.languages, function(language){return language.name;}).join(',');
      }

      if(this.resume.portfolioAttachments.length > 0){
        this.dashboardState.addPortfolios(this.resume.portfolioAttachments);
      }

    });
  }

  ngOnInit() {
    if(!this.resumeId) {
      return;
    }

    this.candidatesStore.getResume(this.resumeId);
  }

  scrollToTop(): void {
    window.scroll(0, 0);
  }

  experienceInYears(years): string {
    if(years < 1) {
      return 'less than a year';
    }

    return years + ' years'
  }

}
